/* Keep the published storefront on native product and policy pages. */
document.addEventListener('DOMContentLoaded', () => {
  const current = new URL(location.href);
  const root = (document.body.dataset.root || '/').replace(/\/$/, '');
  const policies = new Set(['shipping-policy', 'refund-policy', 'terms-of-service', 'privacy-policy', 'contact-information', 'legal-notice']);
  const policy = current.searchParams.get('review_policy');

  // Existing bookmarks to policy review pages now open the official policy.
  if (policies.has(policy)) {
    location.replace(root + '/policies/' + policy);
    return;
  }

  // A saved design-preview product link must remain purchasable on the live theme.
  if (window.Shopify?.theme?.role === 'main' && current.searchParams.has('design_preview')) {
    const model = current.searchParams.get('model');
    if (model && /^ls2-[a-z0-9-]+$/.test(model)) {
      current.pathname = root + '/products/' + model;
      current.searchParams.delete('category');
    }
    ['design_preview', 'model', 'preview_theme_id'].forEach(key => current.searchParams.delete(key));
    location.replace(current.pathname + current.search + current.hash);
  }
});
